export const datadogConfig = {
  clientId: '',
};
